import apiClient from '@/lib/api-client';
import { ApiError } from '@/model/ApiError';
import { Module, Mutation, VuexModule, Action } from 'vuex-module-decorators';
import {
    DeleteLocationRequest,
    Location,
    PostLocationRequest,
    PutLocationRequest,
} from '@/model/Location';
import router from '@/router';

@Module({ namespaced: true, preserveState: false })
export default class LocationsStorage extends VuexModule {
    error: ApiError | null = null;

    locations: Location[] = new Array<Location>();

    @Mutation
    setError(error: ApiError | null): void {
        this.error = error;
    }

    @Mutation
    setLocations(locations: Location[]): void {
        this.locations = locations;
    }

    @Action
    fetchLocations(eventId: number): Promise<void | Location[]> {
        return apiClient
            .get<void, Location[]>(`/events/${eventId}/locations`)
            .then((data: Location[]) => {
                this.context.commit('setLocations', data);
                this.context.commit('setError', null);
                return Promise.resolve(data);
            })
            .catch((error) => {
                if (error?.key === 'security.permission.denied') {
                    router.push({ name: 'NotFound' });
                }

                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    @Action
    postLocation(postLocationRequest: PostLocationRequest): Promise<void> {
        return apiClient
            .post<void>(`/events/${postLocationRequest.eventId}/locations`, {
                ...postLocationRequest.location,
            })
            .then(() => {
                this.context.commit('setError', null);
            })
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    @Action
    putLocation(putLocationRequest: PutLocationRequest): Promise<void> {
        return apiClient
            .put<void>(
                `/events/${putLocationRequest.eventId}/locations/${putLocationRequest.location.id}`,
                {
                    ...putLocationRequest.location,
                },
            )
            .then(() => {
                this.context.commit('setError', null);
            })
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    @Action
    deleteLocation(
        deleteLocationRequest: DeleteLocationRequest,
    ): Promise<void> {
        return apiClient
            .delete<void>(
                `/events/${deleteLocationRequest.eventId}/locations/${deleteLocationRequest.locationId}`,
            )
            .then(() => {
                this.context.commit('setError', null);
            })
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    get getError(): ApiError | null {
        return this.error;
    }

    get getLocations(): Array<Location> {
        return this.locations;
    }
}
